// extracted by mini-css-extract-plugin
export default {"container":"Estimation_container__TsXPW","body":"Estimation_body__-G7tJ"};